import React from 'react'
import StyledList from './List.js'
import EmbeddedImageContainer from '../../EmbeddedAsset.js/components/EmbeddedImageContainer.js'
import EmbeddedMediaContainer from '../../EmbeddedAsset.js/components/EmbeddedMediaContainer.js'
import { PreviewEmbeddedAsset } from '../../EmbeddedAsset.js/index.js'

const Callout = ({ __typename: type, ...rest }) => {
  switch (type) {
    case 'ComponentMediaEmbed':
    case 'componentMediaEmbed':
      return <PreviewEmbeddedAsset {...rest} />
    case 'ContentfulModuleImageAudioVideoEmbed':
      // If it's a video/audio type, use EmbeddedMediaContainer
      if (rest.type === 'Video/Audio') {
        return <EmbeddedMediaContainer {...rest} />
      }
      // Otherwise, use EmbeddedImageContainer for images
      return <EmbeddedImageContainer {...rest} />
    case 'List':
      return <StyledList fields={{ ...rest }} preview />
    case 'ContentfulModuleList':
      return <StyledList {...rest} />
    default:
      return null
  }
}

export default Callout
